import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // For routing
import { Provider } from 'react-redux'; // Redux provider
import App from './App'; // Main App component
import './index.css'; // Global styles (if any)
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { injectStore } from './api/axiosInstance';
import { HelmetProvider } from 'react-helmet-async';

// Inject the store into axiosInstance
injectStore(store);

// Create the root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application
root.render(
  <HelmetProvider>
    <React.StrictMode>
      <Provider store={store}>
        {' '}
        {/* Redux Provider */}
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            {' '}
            {/* Router for navigation */}
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  </HelmetProvider>,
);
